/* Ignacio - ADA Drawer: announce cart changes to screen readers.
 *
 * This was rewritten after Upcart replaced the default cart. It mostly handles
 * a11y, but did not announce a live region for cart updates, so that is still
 * added here.
 */
(function () {
  const REGION_ID = 'dtc-cart-live-region';

  // A screen reader only announces changes to a region that was already in the
  // document, so it is created once and reused rather than built per message.
  function getLiveRegion() {
    let region = document.getElementById(REGION_ID);
    if (region) return region;

    region = document.createElement('p');
    region.id = REGION_ID;
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.className = 'visually-hidden';
    document.body.appendChild(region);

    return region;
  }

  document.addEventListener('dtc:cart-count-changed', (event) => {
    const count = event.detail?.count;
    const message = Number.isInteger(count)
      ? `Shopping cart updated, ${count} ${count === 1 ? 'item' : 'items'}`
      : 'Shopping cart updated';

    const region = getLiveRegion();

    // Clearing first re-announces a message identical to the last one, which
    // happens whenever two changes land on the same total.
    region.textContent = '';
    setTimeout(() => {
      region.textContent = message;
    }, 100);
  });
})();


/* Ruyi - Discount plugin: Input element relies on the placeholder attribute as a fallback to provide an accessible name  */
try {
  const runScript = () => {
    const timeoutDuration = 5000; // 5 seconds
    const targetSelector = "input.lit__discount_input";
    const addTitle = (element) => {
      if (!element.hasAttribute('title')) {
        element.setAttribute('title', 'Enter your discount code or gift card');
      }
    };
    const initTitle = () => {
      const target = document.querySelector(targetSelector);
      if (target) {
        addTitle(target);
        new MutationObserver(() => addTitle(target)).observe(target, {
          attributes: true,
          attributeFilter: ['title'],
        });
        observer.disconnect();
        clearTimeout(timeoutId);
      }
    };
    const observer = new MutationObserver(() => initTitle());
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = setTimeout(() => {
      observer.disconnect();
    }, timeoutDuration);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runScript);
  } else {
    runScript();
  }
} catch (error) { }

/*  Fix free item only purchase */
const checkoutObserver = new MutationObserver((mutations, obs) => {
  const checkoutButtons = document.querySelectorAll('button.checkout-button');
  checkoutButtons.forEach((button) => {
    if (!button.dataset.listenerAdded) {
      button.dataset.listenerAdded = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var form = event.target.closest('form');
        if (!form && button.form) {
          form = button.form;
        } else if (!form) {
          return;
        }
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const newForm = document.querySelector('form[action="/checkout"]');
            if (newForm && cart.total_price != 0) {
              newForm.submit();
            }
          })
          .catch(err => { });
      });
    }
  });
});

checkoutObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// Listen for the Upcart close event and force-remove the open-cc class.
// That class causes the <div class='click-capture"/> element to be blurred. It normally is removed
// when clicked on, but the Upcart plugin adds its own overlay that can itercept the click, leaving the overlay blurry,
// This is a temp fix.
window.addEventListener('aftersell-upcart:public-events:cart-closed', () => document.body.classList.remove('open-cc'));

/* Jay - UpCart: temporarily pause checkout while cart updates are pending.
 * Works across click paths and network clients in this file.
 * Checkout is restored only after cart state is re-validated.
 */
(function () {
  const MUTATING_XHR_PATHS = ["/cart/change.js", "/cart/update.js", "/cart/add.js", "/cart/clear.js"];
  const BLOCKED_CHECKOUT_NAV_PATHS = ["/cart", "/checkout", "/checkouts"];

  let pendingMutations = 0;

  /** Get the Upcart checkout button through the shadow DOM */
  function getCheckoutButton() {
    return document.querySelector("#upCart")?.shadowRoot?.querySelector(".upcart-checkout-button");
  }

  /**
   * Checks if an XHR request path matches known cart mutation endpoints. This
   * is used to determine when to lock the checkout button.
   * @param {string} url Request URL.
   * @returns True if the URL is a cart mutation endpoint.
   */
  function isCartMutatingUrl(url) {
    try {
      const pathname = new URL(url, location.origin).pathname;
      return MUTATING_XHR_PATHS.some((p) => pathname === p || pathname.endsWith(p));
    } catch {
      return false;
    }
  }

  /**
   * Checks if a URL matches known blocked navigation paths. This is used to
   * determine when to block navigation to the checkout page while locked.
   *
   * @param {string} url URL of the navigation target.
   * @returns True if the URL is a blocked navigation path.
   */
  function isBlockedNavigationUrl(url) {
    try {
      const pathname = new URL(url, location.origin).pathname;
      return BLOCKED_CHECKOUT_NAV_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
    } catch {
      return false;
    }
  }

  /**
   * Reads what a click path says about checkout: whether it ran through a
   * checkout button, and the nearest hyperlink it passed through.
   *
   * The button is found by class rather than by href because disableCheckoutButton
   * below rewrites UpCart's href to #/loading while the cart is settling -- the
   * class is the only tell that survives that.
   *
   * @param {HTMLElement[]} elPath All the elements in the path of the click
   * event, including those inside shadow DOMs.
   */
  function readCheckoutClick(elPath) {
    return {
      isCheckoutButton: elPath.some(
        (el) =>
          el?.classList?.contains?.("upcart-checkout-button") ||
          el?.classList?.contains?.("checkout-button") ||
          el?.name === "checkout"
      ),
      hyperlink: elPath.find((el) => el?.tagName === "A" && typeof el.href === "string"),
    };
  }

  /**
   * Checks if any element in the click event path is a checkout button or a
   * hyperlink to the checkout page, which should be blocked when mutations are
   * pending.
   * 
   * @param {HTMLElement[]} elPath All the elements in the path of the click
   * event, including those in shadow DOMs. All are checked to find a know
   * checkout button or hyperlink.
   * @returns 
   */
  function shouldBlockNavigation(elPath) {
    const isCheckoutButton = elPath.some((el) => el?.classList?.contains?.("upcart-checkout-button"));
    if (isCheckoutButton) return true;

    const hyperlink = elPath.find((el) => el?.tagName === "A" && typeof el.href === "string");
    if (hyperlink && isBlockedNavigationUrl(hyperlink.href)) return true;

    return false;
  }

  /**
   * Is this click actually leaving the store for checkout? Narrower than
   * shouldBlockNavigation, which also covers /cart -- our own page, blocked only
   * because it carries a checkout button of its own.
   *
   * @param {{isCheckoutButton: boolean, hyperlink: HTMLAnchorElement|undefined}} click
   */
  function isLeavingForCheckout({ isCheckoutButton, hyperlink }) {
    if (isCheckoutButton) return true;
    if (!hyperlink) return false;

    try {
      const { pathname } = new URL(hyperlink.href, location.origin);
      // /checkout and /checkouts/... plus the cart-side entry points that
      // redirect there: /cart/c/<token> and /cart/<id>:<qty> permalinks.
      return /^\/(checkouts?(\/|$)|cart\/(c\/|\d))/.test(pathname);
    } catch {
      return false;
    }
  }

  /**
   * The checkout button is a link but try hard to disabled it.
   * 
   * - pointer events are disabled to prevent clicks
   * - aria-disabled is set for screen readers
   * - href is changed to prevent navigation on click and original href is saved in a data attribute
   * - tabindex is set to -1 to remove it from the tab order and original tabindex is saved in a data attribute
   */
  function disableCheckoutButton() {
    const button = getCheckoutButton();
    if (!button) return;

    button.style.pointerEvents = "none";
    button.setAttribute("aria-disabled", "true");

    if (!button.hasAttribute("data-dtc-lock-href") && button.hasAttribute("href")) {
      button.setAttribute("data-dtc-lock-href", button.getAttribute("href") || "");
    }
    button.href = '#/loading';

    if (!button.hasAttribute("data-dtc-lock-tabindex")) {
      const currentTabIndex = button.getAttribute("tabindex");
      button.setAttribute("data-dtc-lock-tabindex", currentTabIndex === null ? "" : currentTabIndex);
    }
    button.setAttribute("tabindex", "-1");
  }

  /**
   * Reenables the checkout button by restoring all attributes changed in disableCheckoutButton.
   */
  function enableCheckoutButton() {
    const button = getCheckoutButton();
    if (!button) return;

    button.style.pointerEvents = "";
    button.removeAttribute("aria-disabled");

    if (button.hasAttribute("data-dtc-lock-href")) {
      const href = button.getAttribute("data-dtc-lock-href") || "";
      if (href) {
        button.setAttribute("href", href);
      }
      button.removeAttribute("data-dtc-lock-href");
    }

    if (button.hasAttribute("data-dtc-lock-tabindex")) {
      const previousTabIndex = button.getAttribute("data-dtc-lock-tabindex");
      if (previousTabIndex) {
        button.setAttribute("tabindex", previousTabIndex);
      } else {
        button.removeAttribute("tabindex");
      }
      button.removeAttribute("data-dtc-lock-tabindex");
    }
  }

  document.addEventListener(
    "click",
    /**
     * Checks all page clicks during the capture phase to see if they should be
     * blocked while cart mutations are pending.
     * @param {MouseEvent} e 
     */
    function captureCheckoutClick(e) {
      const elPath = e.composedPath();

      if (pendingMutations > 0) {
        if (shouldBlockNavigation(elPath)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        // Blocked or not, the cart is still settling -- nobody is leaving yet.
        return;
      }

      // Announce a checkout the page is about to lose control of. Fired here
      // because this listener already had to work out what a checkout click
      // looks like, down to UpCart's button inside its shadow root. Capture
      // phase matters: UpCart calls preventDefault() on its own link and does
      // the navigation itself, so by the bubble phase the click reads as
      // handled. dtc-app-back.liquid listens for this to hand the native app
      // back its tab bar before we go.
      if (isLeavingForCheckout(readCheckoutClick(elPath))) {
        document.dispatchEvent(new CustomEvent("dtc:checkout-started"));
      }
    },
    { capture: true }
  );

  /**
   * Increments the count of pending mutations and disables the checkout button
   * to prevent checkout while cart updates are in-flight.
   */
  function lockCheckout() {
    pendingMutations++;
    disableCheckoutButton();
  }

  /**
   * Unlocks the checkout button if there are no more pending mutations,
   * allowing check out again. This must be called the same number of times as
   * lockCheckout to fully restore checkout functionality.
   */
  function unlockCheckout() {
    pendingMutations = Math.max(pendingMutations - 1, 0);
    if (pendingMutations > 0) return;

    // Re-check final cart state before unlocking checkout
    originalFetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        if (cart.total_price > 0) {
          enableCheckoutButton();
        }
        // If only no-cost items remain then keep checkout locked
      })
      .catch(() => {
        // stay locked on network error
      });
  }

  // Keep original fetch for the cart re-check request.
  const originalFetch = window.fetch.bind(window);

  // Override native fetch to intercept cart mutations and lock checkout while they are pending
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input instanceof Request ? input.url : "";

    if (isCartMutatingUrl(url)) {
      lockCheckout();
      return originalFetch(input, init).then(
        (r) => {
          unlockCheckout();
          return r;
        },
        (e) => {
          unlockCheckout();
          throw e;
        }
      );
    }

    return originalFetch(input, init);
  };

  // Same as for fetch, but with XHR
  const origXhrOpen = XMLHttpRequest.prototype.open;
  const origXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._dtcMutating = isCartMutatingUrl(url);
    return origXhrOpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this._dtcMutating) {
      lockCheckout();
      this.addEventListener("loadend", () => unlockCheckout());
    }
    return origXhrSend.apply(this, args);
  };
})();

/* Jay - UpCart: keep the header cart badge in sync with UpCart's cart changes.
 *
 * UpCart owns the cart drawer and everything done inside it. It never updates
 * the theme directly.
 *
 * UpCart fires `cart-updated` for every significant change. Its payload carries
 * UpCart's own cart shape (line items only, so we'd have to count their custom
 * data structure). So the event is used only as a trigger and the count comes
 * from re-rendering the theme's own cart-bubble section: the same request
 * CartDrawer.refresh() makes, which keeps the >99 asterisk and any future badge
 * markup in Liquid.
 */
(function () {
  const BADGE_COUNT_SELECTOR = '.thb-item-count';
  const DEBOUNCE_MS = 150;

  let debounceTimer = null;

  // Bumped per request so a slow response can't overwrite a newer one when
  // someone taps quantity +/- faster than the section round trip.
  let latestRequest = 0;

  /**
   * Re-renders the cart-bubble section and copies its count into every cart
   * badge on the page. Silent on failure: a stale badge beats a thrown error,
   * and the next cart change tries again.
   */
  function refreshCartBadge() {
    const request = ++latestRequest;

    fetch(`${window.location.pathname}?sections=cart-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        if (request !== latestRequest) return;

        // Shopify returns the small rendered HTML for the cart-bubble section.
        // We just parse it and extract count section out.
        const rendered = new DOMParser()
          .parseFromString(sections['cart-bubble'], 'text/html')
          .querySelector(BADGE_COUNT_SELECTOR);
        if (!rendered) return;

        // Replace our counts from the fresh section.
        document.querySelectorAll(BADGE_COUNT_SELECTOR).forEach((badge) => {
          badge.innerHTML = rendered.innerHTML;
        });

        // A count over 99 renders as an asterisk icon, leaving no number to read
        // out, so the live region falls back to a countless message for that.
        const count = parseInt(rendered.textContent.trim(), 10);
        document.dispatchEvent(new CustomEvent('dtc:cart-count-changed', {
          detail: { count: Number.isNaN(count) ? null : count }
        }));
      })
      .catch(() => { });
  }

  // A single cart change can emit more than one event; coalesce them.
  window.addEventListener('aftersell-upcart:public-events:cart-updated', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshCartBadge, DEBOUNCE_MS);
  });
})();
